<template>
  <div class="b-vehicle-compare-bar-card">
    <div class="b-vehicle-compare-bar-card__image">
      <LazyImage
        v-if="image"
        :image="image"
        class="cursor-pointer"
        @click="onClickButton" />
    </div>
    <div>
      <div class="cursor-pointer" @click="onClickButton">
        <div class="extrabold">{{ item.make }} {{ item.model }}</div>
        <div class="b-vehicle-compare-bar-card__description semibold">
          <span>{{ modelNameComputed }}</span>
        </div>
        <div class="b-vehicle-compare-bar-card__price bold">
          <span v-if="!item.vatIncluded">
            {{ item.pricePerMonth }} {{ dictionary.vehiclePriceSuffix }}
          </span>
          <span v-else>
            {{ item.pricePerMonthIncldVat }} {{ dictionary.vehiclePriceSuffix }}
          </span>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-link btn-remove"
        :disabled="recordsLength < 3"
        @click="onClickCard">
        {{ dictionary.removeVehicleButtonText }}
      </button>
    </div>
  </div>
</template>

<script>
import * as lib from './../../../lib/lib'
import mixinsLeasingOffers from '../../mixins/leasingOffers-mixins'
import LazyImage from './../common/LazyImage.vue'

export default {
  components: { LazyImage },
  mixins: [mixinsLeasingOffers],
  props: {
    item: {
      required: true,
      type: Object,
    },
    recordsLength: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  computed: {
    modelNameComputed() {
      if (!this.item) {
        return null
      }
      return this.item.modelDescription
    },

    image() {
      return this.item.galleryImages
        ? {
            url: this.item.galleryImages[0].url,
            alt: this.item.galleryImages[0].alt,
          }
        : null
    },
  },
  methods: {
    onClickCard() {
      this.removeRecordFromCompare({ value: this.item.id })
    },
    onClickButton() {
      window.location.assign(this.item.link.url)
      lib.scrollToTop()
    },
  },
}
</script>

<style scoped lang="scss">
.b-vehicle-compare-bar-card {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;

  img {
    max-height: 40px;
  }

  &__image {
    flex-shrink: 0;
  }

  &__description {
    max-width: fit-content;
    font-size: 12px;
    line-height: 1.1rem;
    min-height: 30px;
  }

  .btn-remove {
    color: #c71818;
    margin-top: 4px;
    // font-size: 13px;
    font-weight: 600;

    &:hover,
    &:focus,
    &:active {
      color: #c71818;
    }
  }
}
</style>
